/** The ping that accompanies a desktop notification (copied from cpanel). */
const NOTIFICATION_SOUND = '/notification-sound.mp3';

/**
 * Browsers only allow notification sound after a user gesture, so cpanel waited
 * for the first click before it would ping. Tracked per page load.
 */
let userHasInteracted = false;

if (typeof document !== 'undefined') {
  document.addEventListener(
    'click',
    () => {
      userHasInteracted = true;
    },
    { once: true },
  );
}

/**
 * Desktop notification + sound for an incoming chat message (cpanel
 * `showBrowserNotification`). Silent when the platform has no Notification API,
 * permission is denied, or the user has not interacted with the page yet.
 */
export async function showChatNotification(title: string, body: string): Promise<void> {
  if (typeof Notification === 'undefined') return;

  const permission = await Notification.requestPermission();
  if (permission !== 'granted' || !userHasInteracted) return;

  new Notification(title, { body, icon: '/favicon.svg' });

  try {
    await new Audio(NOTIFICATION_SOUND).play();
  } catch {
    // The browser blocked autoplay — the visual notification already fired.
  }
}
